import { styled } from '@mui/material';

import { TCurrentUserTeamDto } from '@app-velocity/av-api-v2';
import { useI18n } from '@app-velocity/i18n';

export type TeamTypeBadgeProps = {
  tier: TCurrentUserTeamDto['subscriptionTier'];
};

const StyledBadge = styled('div')(({ theme }) => ({
  fontSize: 12,
  lineHeight: 1.5,
  fontWeight: 300,
  borderRadius: theme.spacing(1),
  padding: `0 ${theme.spacing(1.5)}`,
  color: 'var(--badge-plan-text-color)',
  background: 'var(--badge-plan-background-color)',
}));

export const TeamTypeBadge = ({ tier }: TeamTypeBadgeProps) => {
  const { t } = useI18n();

  if (!tier) return null;

  return <StyledBadge>{t(`teams:badge.${tier}`)}</StyledBadge>;
};
